module.exports = __webpack_public_path__ + "img/southwest-fall-1920x550.f169a3f8.jpg";